import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { PostMeetingData } from './meetingService';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function usePostMeeting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: PostMeetingData) => MeetingService.postMeeting(data).then((response) => response.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [MeetingKey.MEETINGS] });
      void queryClient.invalidateQueries({
        queryKey: [MeetingKey.MEETINGS_INFINITE],
      });
    },
  });
}
